<template>
	<div>
		<div class="table-heading">
			<h2>{{ this.total }} {{ this.total === 1 ? 'Result' : 'Results'}}</h2>
			<UserTableSearch
				@onSearchChange="handleSearchChange"
			/>
		</div>
		<v-client-table
			v-if="!preloaderVisibility"
			v-model="userList"
			:columns="columnsOptions"
			:options="options"
			class="client-table"
			ref="userTable"
		>
			<template slot="h__email">
				<span class="sortable-header" @click="onServerSort('email')">
					{{ getHeading('email') }}
					<span class="sort-indicator" v-if="sortColumn === 'email'">
						{{ sortDir === 'asc' ? '^' : 'v' }}
					</span>
				</span>
			</template>
			<template slot="h__firstName">
				<span class="sortable-header" @click="onServerSort('firstName')">
					{{ getHeading('firstName') }}
					<span class="sort-indicator" v-if="sortColumn === 'firstName'">
						{{ sortDir === 'asc' ? '^' : 'v' }}
					</span>
				</span>
			</template>
			<template slot="h__lastName">
				<span class="sortable-header" @click="onServerSort('lastName')">
					{{ getHeading('lastName') }}
					<span class="sort-indicator" v-if="sortColumn === 'lastName'">
						{{ sortDir === 'asc' ? '^' : 'v' }}
					</span>
				</span>
			</template>
			<template slot="h__dob">
				<span class="sortable-header" @click="onServerSort('dob')">
					{{ getHeading('dob') }}
					<span class="sort-indicator" v-if="sortColumn === 'dob'">
						{{ sortDir === 'asc' ? '^' : 'v' }}
					</span>
				</span>
			</template>
			<template slot="h__age">
				<span class="sortable-header" @click="onServerSort('age')">
					{{ getHeading('age') }}
					<span class="sort-indicator" v-if="sortColumn === 'age'">
						{{ sortDir === 'asc' ? '^' : 'v' }}
					</span>
				</span>
			</template>
			<template slot="h__astrologySign">
				<span class="sortable-header" @click="onServerSort('astrologySign')">
					{{ getHeading('astrologySign') }}
					<span class="sort-indicator" v-if="sortColumn === 'astrologySign'">
						{{ sortDir === 'asc' ? '^' : 'v' }}
					</span>
				</span>
			</template>
			<template slot="h__countryOfBirth">
				<span class="sortable-header" @click="onServerSort('countryOfBirth')">
					{{ getHeading('countryOfBirth') }}
					<span class="sort-indicator" v-if="sortColumn === 'countryOfBirth'">
						{{ sortDir === 'asc' ? '^' : 'v' }}
					</span>
				</span>
			</template>
			<template slot="h__signUpDate">
				<span class="sortable-header" @click="onServerSort('signUpDate')">
					{{ getHeading('signUpDate') }}
					<span class="sort-indicator" v-if="sortColumn === 'signUpDate'">
						{{ sortDir === 'asc' ? '^' : 'v' }}
					</span>
				</span>
			</template>
			<template slot="h__lastActivity">
				<span class="sortable-header" @click="onServerSort('lastActivity')">
					{{ getHeading('lastActivity') }}
					<span class="sort-indicator" v-if="sortColumn === 'lastActivity'">
						{{ sortDir === 'asc' ? '^' : 'v' }}
					</span>
				</span>
			</template>
			<template slot="h__subscription">
				<span class="sortable-header" @click="onServerSort('subscription')">
					{{ getHeading('subscription') }}
					<span class="sort-indicator" v-if="sortColumn === 'subscription'">
						{{ sortDir === 'asc' ? '^' : 'v' }}
					</span>
				</span>
			</template>
			<template slot="h__language">
				<span class="sortable-header" @click="onServerSort('language')">
					{{ getHeading('language') }}
					<span class="sort-indicator" v-if="sortColumn === 'language'">
						{{ sortDir === 'asc' ? '^' : 'v' }}
					</span>
				</span>
			</template>
			<template slot="h__overwrite">
				<span class="sortable-header" @click="onServerSort('overwrite')">
					{{ getHeading('overwrite') }}
					<span class="sort-indicator" v-if="sortColumn === 'overwrite'">
						{{ sortDir === 'asc' ? '^' : 'v' }}
					</span>
				</span>
			</template>
			<router-link
				slot="edit"
				slot-scope="users"
				class="nav-item"
				:to="`/user/edit/${users.row.userId}`"
			>
				Edit
			</router-link>
		</v-client-table>
    <div
        v-if="preloaderVisibility"
        class="table-skeleton" />
		<PreloaderComponent v-if="preloaderVisibility"/>
		<div class="page-size-selector" v-if="!preloaderVisibility">
			<label for="rows-per-page">Rows per page:</label>
			<select id="rows-per-page" :value="limit" @change="handlePageSizeChange">
				<option v-for="opt in pageSizeOptions" :key="`ps-${opt}`" :value="opt">{{ opt }}</option>
			</select>
		</div>
		<Paginate
			v-if="pageCount !== 1 && userList.length"
			v-model="currentPage"
			:page-count="pageCount"
			:container-class="'pagination'"
			:page-class="'page-item'"
			:prev-text="'<'"
			:next-text="'>'"
			:prev-class="'page-item'"
			:next-class="'page-item'"
			:click-handler="paginationHandler"
		/>
		<button @click="modalView = true">
			Export
		</button>
		<ModalWindowComponent v-if="modalView">
			<ExportDialog @close="modalView = false"/>
		</ModalWindowComponent>
	</div>
</template>

<script>
import Paginate from 'vuejs-paginate'
import SolFileAPIInstance from '@/api'
import {tableOptions, columns} from '@/components/userTable/config'
import UserTableSearch from '@/components/userTable/UserTableSearch'
import PreloaderComponent from '@/components/common/PreloaderComponent'
import ExportDialog from '@/components/userTable/ExportDialog'
import ModalWindowComponent from '@/components/common/ModalWindowComponent'

export default {
	name: "usersTable",
	components: {
		Paginate,
		UserTableSearch,
		PreloaderComponent,
		ExportDialog,
		ModalWindowComponent
	},
	data() {
		return {
			options: { ...tableOptions },
			modalView: false,
			deleteUserId: 0,
			userList: [],
			columnsOptions: columns,
			pageCount: 0,
			prefix: '',
			currentPage: 1,
			total: 0,
			searchValue: '',
			offset: 0,
			limit: 10,
			preloaderVisibility: true,
			pageSizeOptions: [10, 25, 50, 100],
			sortColumn: '',
			sortBy: '',
			sortDir: 'asc',
			sortFieldMap: {
				email: 'email',
				firstName: 'firstName',
				lastName: 'lastName',
				dob: 'dob',
				age: 'dob',
				astrologySign: 'astrologicalSign',
				countryOfBirth: 'birthCountry',
				signUpDate: 'signUpDate',
				lastActivity: 'lastActivity',
				subscription: 'subscription',
				language: 'language',
				overwrite: 'overwrite'
			},
		}
	},
	mounted() {
		this.fetchUsers();
	},
	methods: {

		async fetchUsers() {
			const response = await SolFileAPIInstance.getUsers({
				offset: this.offset,
				limit: this.limit,
				...(this.searchValue && {search: this.searchValue.toLocaleLowerCase()}),
				...(this.sortBy && {sortBy: this.sortBy}),
				...(this.sortBy && {sortDir: this.sortDir})
			})
			this.total = response.data.data.total
			this.pageCount = Math.ceil(response.data.data.total / this.limit)
			this.preloaderVisibility = false
			// this.columnsOptions = [...Object.keys(response.data.data.users[0]), 'edit'] dynamic adding new columns
			this.userList = response.data.data.users.map(item => {
				const formattedDob = item.dob ? (new Date(item.dob)).toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' }) : 'Not Entered'
				const ageValue = typeof item.age === 'number' ? item.age : this.calculateAge(item.dob)
				const astrologySignValue = item.astrologySign || this.getAstrologySign(item.dob)
				const countryOfBirthRaw = this.extractTextValue(item.countryOfBirth || item.birthCountry)
				const countryOfBirth = countryOfBirthRaw || 'Not Provided'
				const lastActivityRaw = this.extractTextValue(item.lastActivity)
				const formattedLastActivity = lastActivityRaw ? this.formatDate(lastActivityRaw) : 'Not Provided'
				return {
					...item,
					dob: formattedDob,
					age: Number.isFinite(ageValue) ? ageValue : 'Not Provided',
					astrologySign: astrologySignValue || 'Not Provided',
					countryOfBirth,
					lastActivity: formattedLastActivity,
					language: item.language === 'en' ? 'English' : item.language === 'de' ? 'German' : item.language || 'English'
				}
			})
		},

		handleSearchChange(e) {
			this.preloaderVisibility = true
			this.offset = 0;
			this.currentPage = 1;
			this.searchValue = e;
			this.fetchUsers();
		},

		paginationHandler(props) {
			this.preloaderVisibility = true
			this.offset = (props - 1) * this.limit;
			this.currentPage = props;
			this.fetchUsers();
		},
		handlePageSizeChange(e) {
			const newLimit = Number(e.target.value)
			if (newLimit === this.limit) return
			this.preloaderVisibility = true
			this.limit = newLimit
			this.offset = 0
			this.currentPage = 1
			// keep v-client-table page size in sync
			this.options = { ...this.options, perPage: this.limit }
			this.fetchUsers()
		},
		onServerSort(column) {
			const backendField = this.sortFieldMap[column]
			if (!backendField) {
				return
			}
			if (this.sortColumn === column) {
				this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc'
			} else {
				this.sortColumn = column
				this.sortBy = backendField
				this.sortDir = 'asc'
			}
			this.sortBy = backendField
			this.sortColumn = column
			this.offset = 0
			this.currentPage = 1
			this.preloaderVisibility = true
			this.fetchUsers()
		},
		getHeading(column) {
			return this.options.headings && this.options.headings[column]
				? this.options.headings[column]
				: column
		},
		calculateAge(dob) {
			if (!dob) {
				return null
			}
			const birthDate = new Date(dob)
			if (Number.isNaN(birthDate.getTime())) {
				return null
			}
			const today = new Date()
			let age = today.getFullYear() - birthDate.getFullYear()
			const monthDiff = today.getMonth() - birthDate.getMonth()
			if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
				age -= 1
			}
			return age >= 0 ? age : null
		},
		getAstrologySign(dob) {
			if (!dob) {
				return null
			}
			const birthDate = new Date(dob)
			if (Number.isNaN(birthDate.getTime())) {
				return null
			}
			const month = birthDate.getUTCMonth() + 1
			const day = birthDate.getUTCDate()
			const zodiac = [
				{ sign: 'Capricorn', from: [12, 22], to: [1, 19] },
				{ sign: 'Aquarius', from: [1, 20], to: [2, 18] },
				{ sign: 'Pisces', from: [2, 19], to: [3, 20] },
				{ sign: 'Aries', from: [3, 21], to: [4, 19] },
				{ sign: 'Taurus', from: [4, 20], to: [5, 20] },
				{ sign: 'Gemini', from: [5, 21], to: [6, 20] },
				{ sign: 'Cancer', from: [6, 21], to: [7, 22] },
				{ sign: 'Leo', from: [7, 23], to: [8, 22] },
				{ sign: 'Virgo', from: [8, 23], to: [9, 22] },
				{ sign: 'Libra', from: [9, 23], to: [10, 22] },
				{ sign: 'Scorpio', from: [10, 23], to: [11, 21] },
				{ sign: 'Sagittarius', from: [11, 22], to: [12, 21] }
			]
			for (let i = 0; i < zodiac.length; i += 1) {
				const { sign, from, to } = zodiac[i]
				if (
					(month === from[0] && day >= from[1]) ||
					(month === to[0] && day <= to[1]) ||
					(from[0] > to[0] && ((month === from[0] && day >= from[1]) || (month === to[0] && day <= to[1])))
				) {
					return sign
				}
			}
			return null
		},
		formatDate(value) {
			if (typeof value === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(value.trim())) {
				return value
			}
			const date = new Date(value)
			if (Number.isNaN(date.getTime())) {
				return 'Not Provided'
			}
			return date.toLocaleDateString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' })
		},
		extractTextValue(value) {
			if (value === null || value === undefined) {
				return ''
			}
			if (typeof value === 'string') {
				return value.trim()
			}
			return String(value).trim()
		}
	}
}
</script>

<style lang="scss">

.table-heading {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	overflow: auto;
}

.client-table{
	width: 100%;
	.table-responsive{
		width: 100%;
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
		background-color: #fff;
		border-radius: 6px;
		padding-bottom: 6px;
		table{
			min-width: 1200px;
		}
		@media (min-width: 768px) and (max-width: 1024px) {
			max-width: 800px;
			width: 100%;
			overflow: auto;
		}
	}
	thead{
		@media (max-width: 767px){
			display: none;
		}

		th{
			cursor: pointer; // hint that headers are interactive for sorting
		}
	}
}
.sortable-header{
	display: inline-flex;
	align-items: center;
	gap: 4px;
	color: #35495e;
	font-weight: 600;
}

.sortable-header:hover{
	color: #1f2d3d;
}

.sort-indicator{
	font-size: 0.75rem;
}

.pagination {
	list-style: none;
	display: flex;
	justify-content: center;
	padding: 0;

	.page-item {
		transition: .4s ease all;
		background-color: #34558b;

		a {
			display: inline-block;
			padding: 6px 10px;
			color: white;
			border-radius: 6px;
		}

		&.active {
			background-color: #35495e;
		}

		&.disabled {
			a {
				color: #35495e;
				cursor: not-allowed;
			}

			&:hover {
				background-color: #fff;
			}

			background-color: #fff;
		}

		margin: 3px;
		border-radius: 6px;

		&:hover {
			a {
				color: white;
			}

			background-color: #35495e;
		}
	}
}
.modal-wrapper{
	.modal-container{
		max-width: 400px;
		width: 100%;
		@media screen and (max-width: 767px) {
			padding: 20px 15px;
		}
	}
}
.table-skeleton {
  height: 492px;
}

</style>
